/**
 * CHASER — homepage hero / header scroll states (single source of truth)
 *
 * States:
 * - default: transparent header over hero
 * - chaser-follow-over-hero: follow section rising over fixed hero
 * - chaser-follow-at-menu: follow section passing through header band (menu stays transparent)
 * - chaser-header-solid: follow section cleared header → solid menu, hide fixed hero
 */
(function () {
  const init = () => {
    const header = document.getElementById('header-component');
    if (!header?.hasAttribute('transparent')) return;

    const heroWrapper = document.querySelector('main > .hero-wrapper');
    if (!heroWrapper) return;

    const getFollowSection = () =>
      document.querySelector('main > .hero-wrapper + .shopify-section');

    const update = () => {
      const headerRect = header.getBoundingClientRect();
      const followSection = getFollowSection();

      const followTop =
        followSection instanceof HTMLElement
          ? followSection.getBoundingClientRect().top
          : Number.POSITIVE_INFINITY;

      const atMenu =
        followTop <= headerRect.bottom + 0.5 && followTop > headerRect.top + 0.5;

      const headerSolid = followTop <= headerRect.top + 0.5;

      const followOverHero =
        followSection instanceof HTMLElement &&
        !headerSolid &&
        followTop < heroWrapper.getBoundingClientRect().bottom;

      document.body.classList.toggle('chaser-follow-at-menu', atMenu);
      document.body.classList.toggle('chaser-follow-over-hero', followOverHero);
      document.body.classList.toggle('chaser-header-solid', headerSolid);

      header.toggleAttribute('data-hero-overlap', atMenu);
      header.toggleAttribute('data-hero-passed', headerSolid);
    };

    const onScroll = () => requestAnimationFrame(update);

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);
    document.addEventListener('chaser:layout-updated', update);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
